/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type Person from 'linced-app/models/person';
import type Page from 'linced-app/models/posts/page';
import type School from 'linced-app/models/school';

// Proto: posts.PagePermission.
export default class PagePermission extends Model {
  declare [Type]: 'posts/page-permission';

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @belongsTo('posts/page', { async: true, inverse: null })
  declare pageId: AsyncBelongsTo<Page>;

  @alias('pageId')
  declare page: AsyncBelongsTo<Page>;

  @belongsTo('person', { async: true, inverse: null })
  declare personId: AsyncBelongsTo<Person>;

  @alias('personId')
  declare person: AsyncBelongsTo<Person>;

  @hasMany('person', { async: true, inverse: null })
  declare allowedAccess: AsyncHasMany<Person>;
}
